import * as commWebApi from '@/api/modules/commWebApi';
import { Api, Spectra, SpectraModule } from '@/decorators';

@Spectra({ namespaced: true, name: 'Verification' })
export default class extends SpectraModule {
  @Api() verificationGetStatus = commWebApi.postCommWebApiUserVerificationGetStatus;
  @Api() verificationSubmit = commWebApi.postCommWebApiUserVerificationSubmit;
  @Api() getUserVerifications = commWebApi.postCommWebApiUserVerificationGetDetails;
  @Api() getNotificationList = commWebApi.postCommWebApiNotificationGetNotificationList;
  @Api() notificationRead = commWebApi.postCommWebApiNotificationRead;
  @Api() notificationReadAll = commWebApi.postCommWebApiNotificationReadAll;
  @Api() materialSubmit = commWebApi.postCommWebApiUserVerificationMaterialSubmit;
  @Api() verificationDetail = commWebApi.postCommWebApiUserVerificationDetail;
  @Api() verificationSendWorkEmail = commWebApi.postCommWebApiUserVerificationSendWorkEmail;
  @Api() hasUnreadNotifications = commWebApi.postCommWebApiNotificationHasUnreadNotifications;
}
